import { web as glideInWeb, style as glideInStyle } from './GlideIn';
export { prepare, getNames } from './GlideIn';
function getFixedDirection(options) {
  // TODO replace with structuredClone() when possible
  const duplicate = JSON.parse(JSON.stringify(options));
  const {
    direction
  } = duplicate.namedEffect;
  if (duplicate.namedEffect.startFromOffScreen) {
    duplicate.namedEffect.direction = (direction ?? 270) - 90;
  } else if (typeof direction === 'undefined') {
    duplicate.namedEffect.direction = 270;
  }
  return duplicate;
}
export function web(options, dom) {
  return glideInWeb(getFixedDirection(options), dom);
}
export function style(options) {
  return glideInStyle(getFixedDirection(options));
}
//# sourceMappingURL=GlitchIn.js.map